import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscDoubleArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8 12.738 3.862 8.6l.943-.943L8 10.853l3.195-3.196.943.943L8 12.738Zm0-3.766L3.862 4.834l.943-.943L8 7.086l3.195-3.195.943.943L8 8.972Z"
    />
  </svg>
);
